import React, { useState, useEffect } from "react";
import qubiqcoin from "../../assets/qubiqcoin.png";

const JumpingCoin = ({
  src = qubiqcoin,
  alt = "Qubiq coin",
  size = 30,
  height = 5,
  duration = 400,
  loop = false,      // désactivé : on veut que le saut se joue seulement quand trigger change
  trigger,           // 👈 valeur qui change = lance un saut
  className = "",
  style = {},
}) => {
  const [active, setActive] = useState(false);

  // ✅ Quand trigger change, relance un saut
  useEffect(() => {
    if (trigger !== undefined) {
      setActive(false);
      // petite astuce pour redémarrer proprement l’animation CSS
      requestAnimationFrame(() => setActive(true));

      // optionnel : arrêter l’état "is-jumping" après l’anim
      const timer = setTimeout(() => setActive(false), duration);
      return () => clearTimeout(timer);
    }
  }, [trigger, duration]);

  const vars = {
    "--jump-height": `${height}px`,
    "--jump-duration": `${duration}ms`,
    "--jump-iteration": "1",
    "--coin-size": `${size}px`,
  };

  return (
    <img
      src={src}
      alt={alt}
      className={`jump-img ${active ? "is-jumping" : ""} ${className}`}
      style={{ ...vars, ...style }}
      draggable={false}
    />
  );
};

export default JumpingCoin;
